/*
 * 全局的helper方法
 */

import hljs from 'javascripts/highlight.pack'
import { setOuterHTML } from '../next/javascripts/modules/utils';

window.tower || (window.tower = {});

$.extend(tower, {
  moment: function() {
    return moment.tz.apply(this, [].slice.call(arguments).concat([tower.me.tz]));
  },
  now: function() {
    var serverTime = $("#server-time").val();
    if (serverTime) {
      serverTime = tower.moment(serverTime);
    } else {
      return tower.moment();
    }

    return serverTime.add(moment().diff(tower.lastUpdated), "ms");
  },

  metaKey: function(event) {
    var isMac = /Mac/.test(navigator.userAgent);
    return isMac ? event.metaKey : event.ctrlKey;
  },

  connectUploader: function(btn, uploader, opts) {
    var $btn = $(btn);
    var opts = $.extend({
      multiple: false,
      webkitdirectory: null,
      title: ''
    }, opts);

    $btn.css({
      position: 'relative',
      overflow: 'hidden',
      // Make sure browse button is in the right side
      // in Internet Explorer
      direction: 'ltr'
    }).data('uploader', uploader);

    var $input = null;
    createInput();

    function createInput() {
      $input = $('<input />', {
        multiple: opts.multiple,
        webkitdirectory: opts.webkitdirectory,
        type: 'file',
        title: opts.title,
        name: 'upload_file',
        tabIndex: -1,
        css: {
          position: 'absolute',
          right: 0,
          top: 0,
          fontFamily: 'Arial',
          fontSize: '118px',
          margin: 0,
          padding: 0,
          cursor: 'pointer',
          opacity: 0
        }
      }).appendTo($btn);

      if (!$btn.is('input[type=file]')) {
        $btn.find('input[type=file]').remove();
        $input.appendTo($btn);
      } else {
        $btn.replaceWith($input);
        $btn = $input
      }

      $input.on('change', function(e) {
        uploader.folderUpload = this.webkitdirectory;
        uploader.trigger('inputchange', [e.target.files]);
        uploader.upload($input);
        createInput();
      }).on('click mousedown', function(e) {
        e.stopPropagation();
      });
    }
  },

  handleErrorResponse: function(xhr) {
    if (xhr.statusText === 'abort') return;

    // global handling of 'This team has been locked'
    if (xhr.status == 423 && xhr.statusText.toLowerCase() == 'locked') {
      simple.dialog.message({
        width: 400,
        content: '团队已经锁定，此操作已被禁止。'
      });
    }

    if (console && console.group && console.info) {
      console.group("ajax error");
      console.info(xhr);
      console.groupEnd();
    }

    var result;
    var errorMsg = "";

    try {
      result = JSON.parse(xhr.responseText);
    } catch (e) {
      result = {}
    }

    if (!result || (!result.errors && !result.msg)) {
      return;
    }

    if (result.msg === 'over_limit') return;

    if (result.errors) {
      var proText = false;
      errorMsg += $.map(result.errors, function(err) {
        proText = err.pro;
        return err.msg
      }).join('<br />');
    } else if (result.msg) {
      errorMsg += result.msg;
    }

    if (errorMsg) {
      if (proText) {
        tower.showProPopover($('body'), {
          feature: proText,
          desc: errorMsg,
          center: true
        });
      } else {
        simple.dialog.message({
          width: 400,
          content: errorMsg
        });
      }
    }

    var url = simple.url(location.href).toString('relative');
    if (simple.stack) {
      simple.stack.clearCache(url);
    }
  },

  adjustReadableDate: function(scope) {
    scope = scope || $('body');

    scope.find('[data-readable-date]').each(function() {
      var el = $(this),
          dates = el.data('readable-date'),
          str = '';

      dates = dates.split(',').filter(s => !!s);
      str = dates.map(date => moment.tz(date, tower.me.tz).readableDate()).join(' - ');

      if (!str) return
      el.text(str);
    });
  },

  adjustReadableTime: function(scope) {
    scope = scope || $('body');

    scope.find('[data-readable-time]').each(function() {
      var el = $(this),
          date = el.data('readable-time'),
          str = '';

      date = moment.tz(date, tower.me.tz);
      str = date.readableTime();
      el.text(str);
    });
  },

  updateTrReadableDatetime: function () {
    Array.prototype.forEach.call(
      document.querySelectorAll('tr-readable-datetime'),
      function(element) { element.renderReadableDatetime() },
    );
  },

  mentionConfig: function(textarea) {
    var mention = textarea.data('mention-group');
    var url = textarea.data('mention-url');
    if (!url) {
      var mentionType = textarea.data('mention-type') || 'project';
      url = '/' + mentionType + 's/' + mention + '/mates.json?with_group=true';
    }
    var data = textarea.data('mention-data');

    if (data) {
      var query = [];
      for (var prop in data) {
        query.push(prop + '=' + encodeURIComponent(data[prop]));
      }
      url += ('?' + query.join('&'));
    }

    return {
      items: tower.members[mention],
      url: url,
      nameKey:"nickname",
      pinyinKey:"nickname_pinyin",
      abbrKey:"nickname_pinyin_abbr",
      itemRenderer:function($itemEl,data){
        if (tower.me && (tower.me.guid === data.guid)) {
          return $('<a>');
        }
        var $span = $('span',$itemEl);
        if (data.group) {
          $('<i class="twr twr-user-group"></i>').insertBefore($span);
        } else {
          $('<img>').attr('src',data.gavatar).addClass('avatar').insertBefore($span);
        }
        return $itemEl;
      },
      linkRenderer:function($linkEl,data){
        if (data.group) {
          $linkEl.attr('href', `/teams/${tower.team.guid}/members#${data.guid}`);
        } else {
          $linkEl.attr('href','/members/' + data.guid );
        }
      }
    }
  },

  // 在资源的详情页面，处理页首的资源面包屑
  // 如果当前在项目的sheet里面，就应该不显示此面包屑
  // 如果从通知或者动态等查看资源，应该显示此面包屑
  adjustProjInfo: function() {
    var info = $(".workspace .page-inner .project-info"),
        sheetTitles = $(".workspace .page .link-page-behind");

    sheetTitles.each(function() {
      var title = $(this).text(),
          infoLink = info.find('a:contains("' + title + '")');

      if (infoLink.length) {
        infoLink.closest('span').remove();
      }
    });

    if (!info.find('span').length) {
      info.remove();
    }
  },

  // 创建临时的 Pusher
  tempPusher: function(channelId) {
    var channel;
    if (typeof Pusher === 'undefined' || !channelId) {
      return;
    }

    if (!!tower.tempPusherSocket) {
      tower.tempPusherSocket.disconnect();
    }

    tower.tempPusherSocket = new Pusher(process.env.PUSHER_APP_KEY, {
      wsHost: process.env.PUSHER_EM_HOST,
      wsPort: process.env.PUSHER_EM_PORT,
      wssPort: process.env.PUSHER_EM_PORT,
      encrypted: process.env.PUSHER_EM_SSL == 'true',
      disableFlash: false,
      disableStats: true,
      enabledTransports: ["ws", "flash"],
      activityTimeout: 120000,
      pongTimeout: 3000
    });

    tower.tempPusherSocket.connection.bind('disconnected', function() {
      if (typeof channel !== "undefined" && channel !== null) {
        if (typeof channel.disconnect === "function") {
          channel.disconnect();
        }
      }
      channel = null;
    });

    channel = tower.tempPusherSocket.subscribe(channelId);
    return channel;
  },

  //Old mycolorway.js function
  truncate: function(str, len) {
    return str.length > len ? (str.substring(0, len - 1) + "...") : str;
  },

  encodeHtml: function(value) {
    return (value + "").replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  },

  isScreenView: function(elem, viewOffset, isPart) {
    elem = $(elem);
    viewOffset = viewOffset || 0;

    var offset = elem.offset(),
        win = $(window),
        doc = $(document),
        visible = false;

    if (!isPart &&
        offset.top > doc.scrollTop() + viewOffset &&
        offset.top < doc.scrollTop() + win.height() - elem.outerHeight() - viewOffset) {

      visible = true;
    }

    if (isPart &&
        ((offset.top > doc.scrollTop() + viewOffset &&
          offset.top < doc.scrollTop() + win.height() - viewOffset) ||
         (offset.top + elem.outerHeight() > doc.scrollTop() + viewOffset &&
          offset.top + elem.outerHeight() < doc.scrollTop() + win.height() - viewOffset))) {

      visible = true;
    }

    return visible;
  },

  /* finds the intersection of
   * two arrays in a simple fashion.
   *
   * PARAMS
   *  a - first array, must already be sorted
   *  b - second array, must already be sorted
   *
   * NOTES
   *
   *  Should have O(n) operations, where n is
   *    n = MIN(a.length(), b.length())
   */
  arrayIntersection: function(a, b) {
    var ai = 0,
        bi = 0;
    var result = [];

    while (ai < a.length && bi < b.length) {
      if (a[ai] < b[bi]) {
        ai++;
      } else if (a[ai] > b[bi]) {
        bi++;
      } else /* they're equal */ {
        result.push(a[ai]);
        ai++;
        bi++;
      }
    }

    return result;
  },

  handleAvatarError: function (img) {
    var memberGuid = img.getAttribute('data-member-guid')
    var localStorageKey = 'regenerateLetterAvatar-' + memberGuid
    var useLetterAvatar = /letter_avatar/.test(img.getAttribute('src'))
    var isRegenerated = Boolean(localStorage.getItem(localStorageKey))

    if (!useLetterAvatar || isRegenerated) return

    localStorage.setItem(localStorageKey, true)

    $.ajax({
      url: '/users/generate_letter_avatar',
      method: 'post',
      data: {
        member_guid: memberGuid
      }
    })
  },

  updateCustomBackgroundTopBrightness: function (topBrightness) {
    // Record top brightness.
    $("#custom_background_top_brightness").val(topBrightness);

    // Adjust header dark mode with top brightness of image.
    if (Math.floor(topBrightness) < 60) {
      $(".header").addClass("dark");
    } else {
      $(".header").removeClass("dark");
    }
  },

  updateCustomBackgroundBottomBrightness: function (bottomBrightness) {
    // Record bottom brightness.
    $("#custom_background_bottom_brightness").val(bottomBrightness);

    // Adjust header dark mode with bottom brightness of image.
    if (Math.floor(bottomBrightness) < 60) {
      $(".footer").addClass("dark");
    } else {
      $(".footer").removeClass("dark");
    }
  },

  updateCustomBackgroundColor: function(button) {
    // Build background css.
    var backgroundCss = button.data("value") + " none repeat scroll 0% 0% / auto padding-box border-box";

    // Update background attributes.
    $("#custom_background_url").val("");
    $("#custom_background").val(backgroundCss);
    $("body").css("background", backgroundCss);

    // Update brightness attributes.
    tower.updateCustomBackgroundTopBrightness(button.data("topBrightness"))
    tower.updateCustomBackgroundBottomBrightness(button.data("topBrightness"))
  },

  updateCustomBackgroundImage: function (imageUrl, backgroundUrl, topBrightness, bottomBrightness) {
    // We use JS download image and replace body css when image download finish.
    // Avoid flash when switch body's image url.
    var background = new Image();
    background.src = imageUrl;

    background.onload = function () {
      // Build background css.
      var backgroundCss = "center / cover no-repeat fixed " + "url(" + imageUrl + ")";

      // Update background attributes.
      $("#custom_background_url").val(backgroundUrl);
      $("#custom_background").val(backgroundCss);
      $("body").css("background", backgroundCss);

      // Update brightness attributes.
      tower.updateCustomBackgroundTopBrightness(topBrightness);
      tower.updateCustomBackgroundBottomBrightness(bottomBrightness);
    }
  },

  // compatible edge
  setOuterHTML: function(element, value) {
   setOuterHTML(element, value);
  }

});

Array.prototype.getUnique = function() {
  var n = {},
      r = [];
  for (var i = 0; i < this.length; i++) {
    if (!n[this[i]]) {
      n[this[i]] = true;
      r.push(this[i]);
    }
  }
  return r;
}
